import cls from "./BlogChips.module.css";

interface BlogChipsProps {
    items: string[];
}

export const BlogChips = ({ items }: BlogChipsProps) => {
    return (
        <div className={cls.chips}>
            {items.map((item, index) => (
                <span key={index} className={cls.chip}>{item}</span>
            ))}
        </div>
    );
};
